/** 统一错误处理 mixin，理论上，reply-box的子组件都应该应用此mixin */
export default {
    beforeDestroy() {
        // 组件将被卸载时，清空对应的错误。
        this.handlerError('');
    },
    methods: {
        /** 错误处理 */
        handlerError(msg) {
            this.$emit('error', msg);
        },
    }
}